import keycloak from 'keycloak-js';
import { KEY_CLOAK_URL, KEY_CLOAK_CLIENT_ID } from '../constants';

const keycloakconfig = new keycloak({
  url: KEY_CLOAK_URL,
  realm: 'keycloak-on-aws',
  clientId: KEY_CLOAK_CLIENT_ID,
});

export default keycloakconfig;